// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__WhMmc","left":"InfoRow_left__x3j0N"};